import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import localeMessage from './localeMessage';

const CouplesLocationDialog = ({
  onClose = () => {},
  open = false,
  locale,
}) => {
  if (!open) return <div />;

  return (
    <div className="cld-container">
      <div className="cld-overlay" />
      <div className="cld-body">
        <h2>{localeMessage('partnerRoom', locale)}</h2>
        <div style={{ marginBottom: 20 }}>
          <button
            className="green-button"
            onClick={() => onClose(true)}
            type="button"
          >
            {localeMessage('sameRoom', locale)}
          </button>
        </div>
        <div>
          <button
            className="white-button"
            onClick={() => onClose(false)}
            type="button"
          >
            {localeMessage('joiningSeparately', locale)}
          </button>
        </div>
      </div>
    </div>
  );
};

CouplesLocationDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  locale: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    locale: (state.user && state.user.locale) || 'en',
  };
}

export default connect(mapStateToProps)(CouplesLocationDialog);
